import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { generatePath, useHistory, useRouteMatch } from 'react-router';
import * as ROUTES from '../../config/routes';
import LyfPaymentIntentInfos from '../../my-lemonade-library/src/payments/models/lyf/LyfPaymentIntentInfos';
import orderAction from '../../orders/redux/OrderActions';
import { RootState, useTypedSelector } from '../../redux/root-reducer';
import PaymentLyfEmbedded from './PaymentLyfEmbedded';
import PaymentLyfRedirect from './PaymentLyfRedirect';

interface PaymentLyfProps { }

const PaymentLyf: React.FC<PaymentLyfProps> = () => {
    const { order, payment_infos } = useTypedSelector((state: RootState) => state.order);
    const history = useHistory();
    const dispatch = useDispatch();
    const match = useRouteMatch<ROUTES.RouteParams>();

    const returnHomePage = useCallback(() => {
        dispatch(orderAction.closeModal());
        history.push(generatePath(ROUTES.LocationHome + ROUTES.CategoriesPage, {
            tableLinkKey: match.params.tableLinkKey
        }));
    }, [dispatch, history, match.params.tableLinkKey]);

    if (!payment_infos || !order) {
        returnHomePage();
        return null;
    }

    const lyfPaymentInfo = payment_infos as LyfPaymentIntentInfos;

    return lyfPaymentInfo.payment_url ? (
        <PaymentLyfRedirect
            paymentInfos={lyfPaymentInfo}
            returnHomePage={returnHomePage}
        />
    ) : (
        <PaymentLyfEmbedded
            order={order}
            paymentInfos={lyfPaymentInfo}
            returnHomePage={returnHomePage}
        />
    );
};

export default PaymentLyf;